"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeForAppRegisterRequest = void 0;
var GetPhoneDynamicCodeForAppRegisterRequest = /** @class */ (function () {
    function GetPhoneDynamicCodeForAppRegisterRequest() {
    }
    return GetPhoneDynamicCodeForAppRegisterRequest;
}());
exports.GetPhoneDynamicCodeForAppRegisterRequest = GetPhoneDynamicCodeForAppRegisterRequest;
;
//# sourceMappingURL=getPhoneDynamicCodeForAppRegister.request.js.map